export default __webpack_public_path__ + "static/media/tequip_logo_with_text_for_lightbg.5616ce93.png";